import { faXTwitter, faYoutube, faInstagram, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const socialNetworks = {
    facebook: faFacebookF,
    twitter: faXTwitter,
    instagram: faInstagram,
    youtube: faYoutube,
    linkedin: faLinkedinIn,
}

export const getSocialNetworkIcon = (socialNetwork) => {
    return socialNetworks?.[socialNetwork] || faGlobe;
};